<div class="content__wrapper">
  <!-- Live preview - single image -->
  <div *ngFor="let page of contentData">
    <div class="live_preview" *ngIf="getUILayoutIDByName(page.uiLayout) === 2">
      <div class="preview_content_single" [style.background-color]="page? page.backgroundColor : ''">
        <div class="single_img_layout">
          <div class="logo_section">
            <img [src]="setLogoURL(page.assetID) || 'assets/images/OEM_layout_logo_placeholder.svg'" alt="logo image" />
          </div>
          <div [ngClass]="setImageURL(page.content[0].assetID) ? 'imagePreview' : 'content_section'"
            [ngStyle]="{'background-image': setImageURL(page.content[0].assetID) ? 'url(' + setImageURL(page.content[0].assetID) + ')' : 'assets/images/layout_image_icon.svg'}">
            <h2 class="preview_heading" [ngStyle]="{'color':page ? page.fontColor:''}">
              {{page.content[0].title}}</h2>
            <div class="preview_text" [ngStyle]="{'color':page ? page.fontColor:'','font-size':bodySize}">
              {{page.content[0].subTitle}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Live preview - multi image -->
    <div class="live_preview" *ngIf="getUILayoutIDByName(page.uiLayout) === 1">
      <div class="preview_content multi_img_layout" [style.background-color]="page? page.backgroundColor : ''">
        <div class="small_img">
          <img class="img-fluid" [src]="commonUrl + page.content[0].assetID || 'assets/images/OEM_page1_img_A.svg'"
            alt="image A" />
          <div class="preview_text" [ngStyle]="{'color':page ? page.fontColor:'','font-size':bodyASize}">
            {{page.content[0].subTitle}}</div>
          <img class="img-fluid" [src]="commonUrl + page.content[1].assetID || 'assets/images/OEM_page1_img_B.svg'"
            alt="image A" />
          <div class="preview_text" [ngStyle]="{'color':page ? page.fontColor:'','font-size':bodyBSize}">
            {{page.content[1].subTitle}}</div>
        </div>
        <div class="hero_img">
          <div class="logo_section">
            <img [src]="setLogoURL(page.assetID) || 'assets/images/OEM_layout_logo_placeholder.svg'" alt="logo image" />
          </div>
          <div class="preview_hero_text" [ngStyle]="{'color':page ? page.fontColor:''}">
            {{page.content[2].title}}</div>
          <img [ngClass]="page ? 'heroPreview' : 'img-fluid'"
            [src]="commonUrl + page.content[2].assetID || 'assets/images/OEM_page1_hero_img.svg'" alt="Hero Image" />
        </div>
      </div>
    </div>

    <!-- Live preview - video image -->
    <div class="live_preview" *ngIf="getUILayoutIDByName(page.uiLayout) === 3">
      <div class="preview_content" [style.background-color]="page? page.backgroundColor : ''">
        <div class="video_layout">
          <div class="logo_section">
            <img [src]="setLogoURL(page.assetID) || 'assets/images/OEM_layout_logo_placeholder.svg'" alt="logo image" />
          </div>
          <div class="content_section" *ngIf="!page">
            <!-- Write video instead of image here -->
            <img class="video_icon_filled" alt="video Image" />
          </div>
          <div class="video_preview" *ngIf="page">
            <video [src]="commonUrlVideo + page.content[0].assetID" controls class="video1"></video>
          </div>
          <h2 class="preview_heading" [ngStyle]="{'color':page ? page.fontColor: ''}">
            {{page.content[0].title}}</h2>
        </div>
      </div>
    </div>

    <!-- Live preview - Hotspot content -->
    <div id="livePreview1" class='live_preview' *ngIf="getUILayoutIDByName(page.uiLayout) === 4">
      <div class="preview_content_hotspot">
        <div id="livePreview1ImageSection" class="hotspot_small_img_s">
          <div id="livePreview1LogoSection" class="logo_section">
            <img [src]="setLogoURL(page.assetID) || 'assets/images/OEM_layout_logo_placeholder.svg'"
              alt="hotspot logo image" />
          </div>
        </div>
        <div class="openPopup">
          <button class="open-modal-button" (click)="openModal(page?.hotspots?.hotspot1?.assetUrl,page?.hotspots.hotspot1?.assetType,page.pageNum)">
            <span i18n="@@pages-view.pages.hotspots.preview">Preview the full content</span>
          </button>
        </div>        
        <div class="imageASection sub">
          <div id="imageAHotspotSection" class="hotspot_imageA">
            <img class="img-fluidH" src="{{page?.hotspots?.hotspot1?.assetUrl ||'assets/images/hotspot_imageA.png'}}"
              alt="Image A"  *ngIf="page?.hotspots?.hotspot1?.assetType !== 'mp4' && page?.hotspots?.hotspot1?.assetType !== 'mpeg4'"/>
            <!-- for video-->
            <video src="{{page?.hotspots?.hotspot1?.assetUrl+'#t=0.1'}}" class="video1" *ngIf="page?.hotspots?.hotspot1?.assetType === 'mp4' || page?.hotspots?.hotspot1?.assetType === 'mpeg4'" class="img-fluidH"></video>
          </div>
          <div class="headingBodySection">
            <div class="heading-container" *ngFor="let i of [1,2,3,4];">
              <div class="title-and-icon">
                <span class="hotspot_text" [ngStyle]="{'color': page?.hotspots['hotspot'+i]?.headingColor}">{{
                  page?.hotspots['hotspot'+i]?.heading.substring(0,15) }}</span>
                <span class="plus-icon" *ngIf="page?.hotspots['hotspot'+i]?.heading" [ngStyle]="{'color': page?.hotspots['hotspot'+i]?.headingColor}"></span>
              </div>
              <div *ngIf="isOpen === i" class="content">
                <!-- <p [ngStyle]="{'color': page?.hotspots['hotspot'+i]?.bodyColor,'font-size': page?.hotspots['hotspot'+i]?.bodyFontSize}">{{ page?.hotspots['hotspot'+i]?.body.length>75 ? page?.hotspots['hotspot'+i]?.body.substring(0,75)+'...' : page?.hotspots['hotspot'+i]?.body }}</p> -->
              </div>
              <hr *ngIf="page?.hotspots['hotspot'+i]?.heading"  [ngStyle]="{'border-color': page?.hotspots['hotspot'+i]?.headingColor}"/>
            </div>
          </div>
          <div class="modal-overlay" *ngIf="isModalOpen[page.pageNum-1]">
            <div class="modal">
              <span class="close-icon" (click)="closeModal()">
                <img src="assets/images/popup_close_button.svg" alt="close icon" />
              </span>
              <!--Pop-up body section-->
              <div id="livePreview1" class='live_preview popup-min-width'>
                <div class="preview_content_hotspot popup" [style.background-color]="page? page.backgroundColor : ''">
                  <div id="livePreview1ImageSection" class="hotspot_small_img">
                    <div id="livePreview1LogoSection" class="logo_section">
                      <img [src]="setLogoURL(page.assetID) || 'assets/images/OEM_layout_logo_placeholder.svg'"
                        alt="hotspot logo image" />
                    </div>
                  </div>
                  <div class="imageASection">
                    <div id="imageAHotspotSection" class="hotspot_imageA">
                      <img class="img-fluidH_new" *ngIf="(hotSpotAssetType !== 'mp4' && hotSpotAssetType !== 'mpeg4') || !hotSpotAssetType"
                      src="{{(isOpen? hotSpotPopUpUrl:page?.hotspots?.hotspot1?.assetUrl) || 'assets/images/hotspot_imageA.png'}}"
                      alt="Image A" />
                      <video src="{{(isOpen? hotSpotPopUpUrl:page?.hotspots?.hotspot1?.assetUrl)}}" class="video1" controls  *ngIf="(hotSpotAssetType == 'mp4' || hotSpotAssetType == 'mpeg4')" class="img-fluidH_new"></video>
                    </div>
                    <div class="headingBodySection">
                      <div class="heading-container" *ngFor="let i of [1,2,3,4];">
                        <div class="title-and-icon" (click)="toggleAccordion(i,page?.hotspots['hotspot'+i]?.assetUrl,page?.hotspots['hotspot'+i]?.assetType)">
                          <span class="hotspot_text accordian-icon" [ngStyle]="{'color': page?.hotspots['hotspot'+i]?.headingColor,'cursor': isOpen === i ? 'default' : 'pointer'}"
                            i18n="@@pages-view.pages.hotspots.heading">{{ page?.hotspots['hotspot'+i]?.heading}}</span>
                          <span class="" *ngIf="page?.hotspots['hotspot'+i]?.heading" [ngStyle]="{'color': page?.hotspots['hotspot'+i]?.headingColor,'cursor': isOpen === i ? 'default' : 'pointer'}"
                             [ngClass]="isOpen === i ?  'minus-icon' : 'plus-icon'"></span>
                        </div>
                        <div *ngIf="isOpen === i" class="content">
                          <p [ngStyle]="{'color': page?.hotspots['hotspot'+i]?.bodyColor,'font-size': page?.hotspots['hotspot'+i]?.bodyFontSize}"
                            i18n="@@pages-view.pages.hotspots.popup.body">{{ page?.hotspots['hotspot'+i]?.body}}</p>
                        </div>
                        <hr *ngIf="page?.hotspots['hotspot'+i]?.heading" [ngStyle]="{'border-color': page?.hotspots['hotspot'+i]?.headingColor}"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>